import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const truncate = (text: string, max = 40) => {
  if (!text) return '';
  return text.length > max ? text.slice(0, max) + '...' : text;
};
